import {
  call,
  put,
  select,
  take,
} from 'redux-saga/effects';

import {
  RECEIVE_CURRENT_USER_DETAILS,
} from '../../constants/actionTypes';
import {
  FEATURE_LIST,
} from '../../constants/featureFlags';

import { reqUserDetails } from '../../actions/userActions';
import { reqCurrentUserDetails } from '../../actions/currentUserActions';

import { initialize as initializeFeatureFlags } from '../../utils/featureFlags';
import { receiveFeatures, reqFeatures } from '../../actions/featureActions';


export function* getUserData() {
  const { currentUser, user } = yield select();
  const currentUserId = currentUser.clientId;

  yield put(reqCurrentUserDetails(currentUserId));
  const { userDetails: currentUserData } = yield take(
    RECEIVE_CURRENT_USER_DETAILS
  );
  const { keys, values } = yield call(
    initializeFeatureFlags,
    currentUserData.id,
    currentUserData.countryCode
  );
  yield put(receiveFeatures(keys, values));

  if (user.isProxying) {
    yield put(reqUserDetails(user.id, true));
  } else {
    yield put(reqFeatures(FEATURE_LIST));
  }
}